import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=65cc37ca&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=65cc37ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc37ca",
  null
  
)

export default component.exports